import { Root } from "./Carousel.Root";
import { Item } from "./Carousel.Item";

export default {
  Root,
  Item,
};
